import React from 'react';
import ReactDOM from 'react-dom';
import GlobalStyles from "./GlobalStyles";
import 'bootstrap/dist/css/bootstrap.min.css';
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";
import BrainzRoutes from './BrainzRoutes';
import reportWebVitals from './appConfigs/reportWebVitals';


ReactDOM.render(
  <React.StrictMode>
    <GlobalStyles/>
    <I18nextProvider  i18n={i18next}>
      <BrainzRoutes />
    </I18nextProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
